export const errors = {
  NETWORK_ERROR: {
    title: 'Connection Error',
    description: 'Please check your internet connection.',
    buttonLabel: 'Try Again',
  },
  SERVER_ERROR: {
    title: 'Something Went Wrong',
    description: 'Please try again later.',
    buttonLabel: 'Try Again',
  },
  TIMEOUT: {
    title: 'Request Timeout',
    description: 'The request took too long.',
    buttonLabel: 'Try Again',
  },
  SERVICE_UNAVAILABLE: {
    title: 'Service Unavailable',
    description: 'The service is temporarily unavailable.',
    buttonLabel: 'Try Again',
  },
  UNAUTHORIZED: {
    title: 'Session Expired',
    description: 'Please log in again.',
  },
  SESSION_EXPIRED: {
    title: 'Session Expired',
    description: 'Your session has expired. Please log in again.',
  },
  INVALID_CREDENTIALS: {
    title: 'Invalid Credentials',
    description: 'The credentials you entered are incorrect.',
  },
  VALIDATION_ERROR: {
    title: 'Validation Error',
    description: 'Please check your input and try again.',
  },
  NOT_FOUND: {
    title: 'Not Found',
    description: 'The requested resource was not found.',
  },
  INCORRECT_CODE: {
    title: 'Incorrect Code',
    description: 'The code you entered is incorrect. Please try again.',
  },
  EXPIRED_CODE: {
    title: 'Code Expired',
    description: 'The code has expired. Please request a new one.',
  },
  RESTART_FLOW: {
    title: 'Please Try Again',
    description: 'Something went wrong. Please start over.',
  },
  UNKNOWN: {
    title: 'Error',
    description: 'An unexpected error occurred.',
    buttonLabel: 'Try Again',
  },
  SMS_UNSUBSCRIBED: {
    title: "We couldn't send the code to {{phoneNumber}}",
    description: 'It looks like messages to this phone are blocked. Please update your number to continue.',
    buttonLabel: 'Update Phone Number',
  },
  SMS_INVALID_NUMBER: {
    title: 'Invalid Phone Number',
    description: 'The phone number provided is not valid. Please check and try again.',
  },
  INVALID_PHONE: {
    title: 'Invalid Phone Number',
    description: 'Please enter a valid phone number.',
  },
  PHONE_ALREADY_IN_USE: {
    title: 'Phone Already in Use',
    description: 'This phone number is already associated with another account.',
  },
  EMAIL_ALREADY_IN_USE: {
    title: 'Email Already in Use',
    description: 'This email is already associated with another account.',
  },
  SMS_UNREACHABLE: {
    title: "We couldn't reach this number",
    description: 'Please try a different phone number.',
  },
  INVALID_ADDRESS: {
    title: 'Invalid Address',
    description: 'The address provided is not valid for medication delivery. Please update your address.',
    buttonLabel: 'Update address',
  },
  PO_BOX_FOUND: {
    title: 'PO Box Address Not Accepted',
    description: 'We cannot deliver medications to PO boxes. Please use a physical address.',
    buttonLabel: 'Update address',
  },
  SHIPPING_ADDRESS_LOAD_FAILED: {
    title: 'Unable to load address',
    description: 'Please try again.',
    buttonLabel: 'Retry',
  },
  PHARMACY_LOAD_FAILED: {
    title: 'Unable to load pharmacy',
    description: 'Please try again.',
    buttonLabel: 'Retry',
  },
  SCHEDULING: {
    failedToLoad: 'Failed to load visit information',
    activeVisitExists: 'You already have an active visit scheduled.',
    failedToSchedule: 'Failed to schedule visit',
  },
  INVALID_LINK: {
    title: 'Invalid Link',
    description: 'Please close this page and try again.',
  },
  INSURANCE_ADD_FAILED: {
    title: 'Unable to Add Insurance',
    description: "We couldn't add your insurance. Please try again.",
    buttonLabel: 'Try Again',
  },
  INSURANCE_UPDATE_FAILED: {
    title: 'Unable to Update Insurance',
    description: "We couldn't update your insurance. Please try again.",
    buttonLabel: 'Try Again',
  },
  INSURANCE_REMOVE_FAILED: {
    title: 'Unable to Remove Insurance',
    description: "We couldn't remove your insurance. Please try again.",
    buttonLabel: 'Try Again',
  },
  INSURANCE_OCR_FAILED: {
    title: 'Unable to Scan Card',
    description: "We couldn't read your insurance card. Please try again or enter your information manually.",
    buttonLabel: 'Try Again',
  },
};
